import PaytableComponent from "slotworks/components/paytable/paytable-component";
import { PaginationMode } from "slotworks/components/ui/pagination-component";
import Layers from "slotworks/graphics/layers/layers";
import { AbstractControl, Control } from "slotworks/smart-ui/controls/control";
import ControlOptions from "slotworks/smart-ui/options/control-options";
import HeadlessSmartUIGroup from "slotworks/smart-ui/smart-ui-group";

export default class PaytableControl extends AbstractControl implements Control {

    protected paytableComponent: PaytableComponent;

    public setup(name: string, layer: Layers, assetName: string, assetNames: string[], smartUIGroup: HeadlessSmartUIGroup) {
        super.setup(name, layer, assetName, assetNames, smartUIGroup);

        this.initPayTableComponent();

        const nextButton = this.layer.getFlexiButton(assetName + "_next");
        const prevButton = this.layer.getFlexiButton(assetName + "_previous");
        const closeButton = this.layer.getFlexiButton("close");
        const pageNumber = this.layer.getFlexiText("page_number");

        this.paytableComponent.addControls(nextButton, prevButton, closeButton, pageNumber);

        this.paytableComponent.show();
    }

    public updateOptions(options: ControlOptions) {
        this.paytableComponent.updateOptions(options);
    }

    public destroy() {
          this.paytableComponent.destroy();
    }

    public setVisible(visible: boolean) {
        if (visible) {
            this.paytableComponent.show();
        } else {
            this.paytableComponent.hide();
        }
    }

    public setEnabled(enabled: boolean) {
        if (!enabled) {
            this.paytableComponent.disable();
        } else {
            this.paytableComponent.enable();
        }
    }

    protected onChangeHandler = (value: number) => {
        //
    }

    protected initPayTableComponent() {
        this.paytableComponent = new PaytableComponent(Layers.PaytableContent, this.layer, "paytable", PaginationMode.PAGIFY);
    }
}
